export default {
  title: "Account",
  description: "Very early version with much more to come later. Stay tuned!",
  networkFailure:
    "Oops! Looks like we’ve encountered some issue loading this section. Try refreshing the page or let us know through feedback.",
  tileAction: {
    dashboard: {
      alert: {
        title: "Account Dashboard",
        body: "Just before we load the dashboard here, we need to verify your access to Sisense",
      },
    },
  },
};
